import React, { useMemo } from 'react';
import styles from './ProfileTemplate.module.scss';
import { useFetch } from 'hooks/useFetch';
import { userEndpoints } from 'hooks/endpoints';
import LoadingSpinner from 'component/Custom/LoadingSpinner/LoadingSpinner';
import formatDate from 'helpers/formatDate';
import InfoCard from 'component/atom/info-card/InfoCard';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useNavigate } from 'react-router-dom';
const emailSvg = '/images/email.svg';
const phoneSvg = '/images/phone.svg';
const departmentSvg = '/images/department.svg';
const calendarSvg = '/images/calendar.svg';

const getInitials = (first = '', last = '') => {
  const f = String(first || '').trim();
  const l = String(last || '').trim();
  const a = f ? f[0] : '';
  const b = l ? l[0] : '';
  const res = (a + b).toUpperCase().trim();
  return res || 'U';
};

const ProfileTemplate = () => {
  const navigate = useNavigate();
  const { data, isFetching } = useFetch(
    ['userAuth'],
    userEndpoints?.getAuthUser(),
  );

  const user = data?.data?.authUser || data?.authUser || data?.data || {};

  const fullName = useMemo(() => {
    const name = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
    return name || user?.username || 'User';
  }, [user?.firstName, user?.lastName, user?.username]);

  const email = user?.displayEmail || user?.email || '—';
  const phone = user?.phone || '—';

  const department = user?.department || '—';
  const role = user?.roleName || '—';

  const memberSince = user?.memberSince
    ? formatDate(user.memberSince)
    : formatDate(user?.lastLogin);

  const initials = getInitials(user?.firstName, user?.lastName);

  if (isFetching) return <LoadingSpinner showSpinner />;

  return (
    <div className={styles.profileCont}>
      <div className={styles.profileCard}>
        {/* <div className={styles['edit-profile']}>
          <SvgWithBranding
            type='edit'
            onClick={() => navigate(`edit/${user?.userId}`)}
          />
        </div> */}

        <div className={styles.avatar}>{initials}</div>
        <div className={styles.profileMain}>
          <p className={styles.name}>{fullName}</p>
          <p className={styles.email}>{email}</p>
        </div>
      </div>

      <div className={styles.grid}>
        <InfoCard icon={emailSvg} label='Email' value={email} />
        <InfoCard icon={phoneSvg} label='Phone' value={phone} />
        <InfoCard icon={departmentSvg} label='Department' value={department} />
        <InfoCard
          icon={calendarSvg}
          label='Member Since'
          value={memberSince}
        />{' '}
        <InfoCard label='Role' value={role} />
      </div>
    </div>
  );
};

export default ProfileTemplate;
